import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import DynamicRichTextSectionItem from './DynamicRichTextSectionItem/DynamicRichTextSectionItem';

class WrapUpSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        sectionItemId: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, sectionItemId, isGlobalSectionItem } = this.props;
        return (
            <div key={`${memberReference}-${sectionItemId}`} className={'col-12 shortEssaySectionItem'}>
                <div className={'row'}>
                    <DynamicRichTextSectionItem {...this.props} isWrapUp />
                </div>
                <div className={'row'}>
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.hideContentRelevancyQuestion`
                                : 'content.hideContentRelevancyQuestion'
                        }
                        label={'Hide Content Relevancy Question'}
                        className={'col-12 horizontal-button'}
                        disabled={isGlobalSectionItem}
                        component={BasicToggle}
                        styleProps={{ horizontal: true }}
                        id={'hide-content-relevancy-question-toggle'}
                    />
                </div>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.resources` : 'content.resources'}
                            label={'Resources'}
                            className={'col-12'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            rows={3}
                            readOnly={isGlobalSectionItem}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default WrapUpSectionItem;
